<div class="content star-auth-dialog p-5 lg:p-5">
  <div class="close-button-container absolute">
    <button
      type="button"
      class="close-button button-reset focus-link h-4 w-4"
      [attr.aria-label]="'core.auth_dialog.close' | translate"
      (click)="closeDialog()">
      <rd-shared-icon
        class="close-icon"
        [iconSymbol]="'icon-close'"></rd-shared-icon>
    </button>
  </div>
  <h1 class="login-header typo-emphasis-2-desktop mb-4 mt-5 text-center">
    {{ 'core.auth_dialog.login_header' | translate }}
  </h1>
  <p
    class="login-description typo-emphasis-8-desktop my-0 text-center"
    [innerHTML]="'core.auth_dialog.login_description' | translate"></p>

  <rd-shared-button
    *ngIf="popupSettingService.shouldRenderLoginButton"
    class="login-button mx-auto lg:mt-5"
    [buttonClass]="'login-button'"
    [buttonTheme]="'primary'"
    [buttonText]="'core.auth_dialog.login_button' | translate"
    (clickFn)="redirectToLoginUrl()">
  </rd-shared-button>

  <p
    class="register-content typo-text-mobile lg:typo-text-desktop mb-3 mt-4 text-center lg:mb-0"
    *ngIf="popupSettingService.shouldRenderRegisterLink">
    <span class="register-text">
      {{ 'core.auth_dialog.register_text' | translate }}
    </span>
    <button
      class="button-reset register-link typo-text-mobile focus-link lg:typo-text-desktop my-0 underline"
      (click)="redirectToEnrollUrl()">
      {{ 'core.auth_dialog.register_link' | translate }}
    </button>
  </p>
</div>
